import Moment from "react-moment";

const moment = (date) => {
  return <Moment date={date} fromNow ago />;
};
export default moment;
